import DeleteButton from './DeleteButton'
import EditableLabel from './EditableLabel'
import InlineInput from './InlineInput'

export default {
  DeleteButton,
  EditableLabel,
  InlineInput
}
